import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import "angular-cookies";
import auth from "../../services/auth.js";
import env from "../../services/env.js";
import security from "../../services/security.js";

class SigninController {
  constructor(
    $http,
    $localStorage,
    $state,
    $location,
    $window,
    $stateParams,
    AuthService,
    SignonService,
    EnvService,
    $timeout,
    SecurityService,
    $rootScope,
    $scope,
    TrackingService,
    $cookies,
    $social,
    validation
  ) {
    this.name = "signin";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$window = $window;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$signon = SignonService;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.$social = $social;
    this.$tracking = TrackingService;
    this.$scope = $scope;
    this.posting_data = {};
    this.errors = [];
    this.signInDisabled = true;
    this.email = "";
    this.$cookies = $cookies;
    this.$stateParams = $stateParams;
    this.preserve_posting_data = false;
    this.password = "";
    this.is_home_footer = true;
    this.logging_in = false;
    this.signInUrl =
      "jbl/v1/login?format=json&fields=username,email,id,company.id,company.isVerified,authorities,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.defaultPlan.companyFeePct,company.billingContactInfo.email,company.defaultPlan.requiresSubscription,company.undeletedPaymentInfos.bankName,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.isMobileVerified,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.ein,company.mainContactInfo.state,company.mainContactInfo.zipCode,company.description,company.autoAccept,company.autoManage,company.enableSubscription,company.payByInvoice,company.sendInvoice,company.name,company.legalCompanyName,bgCheckStatus,company.undeletedPaymentInfos.stripeId,acceptedBackgroundCheck";
    this.loginUrlWithValidate =
      "jbl/v1/validate?format=json&fields=username,email,id,company.id,company.isVerified,authorities,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.defaultPlan.companyFeePct,company.billingContactInfo.email,company.defaultPlan.requiresSubscription,company.undeletedPaymentInfos.bankName,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.isMobileVerified,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.mainContactInfo.city,company.ein,company.mainContactInfo.state,company.mainContactInfo.zipCode,company.description,company.autoAccept,company.autoManage,company.enableSubscription,company.payByInvoice,company.sendInvoice,company.name,company.legalCompanyName,bgCheckStatus,company.undeletedPaymentInfos.stripeId,acceptedBackgroundCheck";
    //"jbl/v1/login?format=json&fields=username,id,company.id,company.isVerified,isVerified,billingTutorialTracking,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName";
    //"jbl/v1/login?format=json&fields=username,dateBirth,ssn,isVerified,video1,brands,id,notifPref.jobbleTypes,smsChatNotificationOn,profilePictureUri,company.industryType.id,billingTutorialTracking,emailChatNotificationOn,firstName,dateCreated,lastName,access_token,company.name,company.id,company.payPerConnect,company.sendInvoice,company.autoAcceptLimitTimeMark,company.defaultPlan.requiresSubscription,company.billingContactInfo.email,company.enableSubscription,company.payByInvoice,company.invoiceMarkup,bio,homeContactInfo.streetLine1,homeContactInfo.isMobilePhoneVerified,homeContactInfo.streetLine2,homeContactInfo.zipCode,homeContactInfo.city,homeContactInfo.state,homeContactInfo.phoneMobile,company.mainContactInfo.phoneMobile,company.mainContactInfo.streetLine1,company.dateCreated,company.mainContactInfo.state,company.mainContactInfo.city,company.mainContactInfo.zipCode,controlChannel,email,isVerified,company.isVerified,company.defaultPlan.id,company.defaultPlan.name,company.defaultPlan.description,company.defaultPlan.jobblerFeePct,company.defaultPlan.companyFeePct,company.totalNumberOfCircles,company.autoAccept,company.totalNumberOfCloseEvents,company.totalNumberOfDraftEvents,company.totalNumberOfPublishedEvents,company.totalNumberOfEvents,company.totalNumberOfInvoiceFiles,company.totalNumberOfNonCloseEvents,company.circleOfConnectedJobblers.id,company.undeletedPaymentInfos.id,company.undeletedPaymentInfos.cardBrand,company.undeletedPaymentInfos.validated,company.undeletedPaymentInfos.cardExpirationMonth,company.undeletedPaymentInfos.cardExpirationYear,company.undeletedPaymentInfos.cardToken,company.undeletedPaymentInfos.last4,company.undeletedPaymentInfos.bankName,company.postingTypesAllowed,company.undeletedPaymentInfos.stripeId,company.undeletedPaymentInfos.nickname,company.partnernumberOfCompletedJobbles,numberOfApplications,numberOfApprovedApplications,numberOfPendingApplications,numberOfQuittedApplications,numberOfWithdrawnApplications,numberOfRejectedApplications,acceptedWebAgreement,acceptedMobileAgreement,acceptedPrivacyPolicy,acceptedCookiePolicy"
    this.currentUser = this.$auth.getUserData();
    this.result = {status: "", message: ""};
    this.remain_loading_count = 0;
    this.jqueryCleanUp();
    this.$rootScope.channels = undefined;
    this.$rootScope.activeMessages = undefined;
    this.$rootScope.activeChannel = undefined;
    this.$rootScope.arrayOfUniqueOnlineUsers = undefined;
    this.$rootScope.lengthOfChannelsCreated = undefined;
    this.$rootScope.messagingHasBeenInitiated = undefined;
    this.initFB();
    this.set_focus();
    this.parse_params(this.$stateParams);
    //$location.search('key', null)
    this.$validation = validation;
    this.validation = {
      email: {},
    };

    this.checkThirdPartyParams();
    this.focusOnEmail();
  }

  parse_params(params) {
    var _this = this;
    if (params.onRefresh === true) {
      this.$timeout(() => {
        window.location.reload();
        return;
      }, 1300);
    }
    if (params.preserve === true) {
      _this.preserve_posting_data = true;
      _this.posting_data = params;
    }
    let urlParams = this.$location.$$search;
    if (urlParams) {
      let email = urlParams.companySignInEmail;
      if (email) {
        let emailEncoded = encodeURI(email);
        let emailDecoded = decodeURIComponent(emailEncoded.replace("%20", "+"));
        _this.email = emailDecoded;
        _this.password = _this.$env.EnvironmentConfig.registeredUserPassword;
        if (_this.$auth.isLoggedIn()) {
          _this.$auth.signOut();
          _this.$timeout(function () {
            _this.signIn();
          }, 1000);
        } else {
          _this.setLoader();
          _this.signIn();
        }
      }
    }
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  validateField(field, value, validateMethod, constructError) {
    const {isValid, errors} = validateMethod(value);

    this.$timeout(() => {
      this.validation[field] = {
        valid: isValid,
        style: {borderColor: isValid ? "#74cf59" : "red"},
        message: constructError(errors),
      };
    });

    return isValid;
  }

  submitOnEnter(e) {
    if (e.keyCode === 13) {
      this.signIn();
    }
  }

  handleEmailChange() {
    const {EmailValidator} = this.$validation;
    return this.validateField("email", this.email, EmailValidator.validateEmail, EmailValidator.constructErrorMessage);
  }

  go_to_signup(link) {
    var _this = this;
    let d = _this.posting_data;
    if (link === 2) {
      _this.$state.go("signup");
    } else {
      _this.$state.go("signup-company", d);
    }
  }

  signIn() {

    if (this.signInDisabled === true) {
      return;
    }

    this.$timeout(() => {
      this.logging_in = true;
    });
    var _this = this;
    var req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + _this.signInUrl,
      data: {
        username: this.email,
        password: this.password,
      },
    };
    this.$http(req).then(
      function (data) {
        _this.result.status = data.data.status;
        let user = {};
        if (data.data.company.id) {
          if (data.data.status == "error" || !data.data.company) {
            _this.result.status = "error";
            _this.result.message = "Login failed. Please check your credentials and try again.";
            return;
          }
          _this.$tracking.reportUserLogin(data.data);
          data.data.companyId = data.data.company.id;
          _this.$localStorage.logged_user = data.data;
          user = data.data;
          _this.$stateParams.t = user.access_token;
          _this.$rootScope.jobbleTypes = _this.$env.EnvironmentConfig.jobble_types;
          if (_this.connectUser !== true) {
            _this.$auth.handlePaymentInfos(user, _this.$stateParams);
          } else {
            _this.checkThirdParty(user, "business");
          }
          _this.logging_in = false;
        } else {
          _this.$localStorage.logged_user = data.data;
          _this.removeBodyClass();
          let u = data.data;

          _this.fbTrackLogin(u);
          _this.$rootScope.jobbleTypes = _this.$env.EnvironmentConfig.jobble_types;
          if (_this.connectUser !== true) {
            _this.$state.go("jobs");
          } else {
            _this.checkThirdParty(u, "jobbler");
          }
          _this.logging_in = false;
          _this.unSetLoader();
        }
      },
      (error) => {
        console.log("down here?");
        console.dir(error);
        _this.$timeout(() => {
          _this.logging_in = false;
        });
        if (error.status === 401) {
          if (error.data === "") {
            _this.result.status = "error";
            _this.result.message = "Login failed. Please check your credentials and try again.";
          } else if ((error.data.message = "User is disabled")) {
            _this.result.status = "error";
            _this.result.message = "Account Suspended. If you feel this has been done by mistake please contact support.";
          } else {
            _this.result.status = "error";
            _this.result.message = "Login failed. Please check your credentials and try again.";
          }
        } else {
          _this.result.status = "error";
          _this.result.message = "Login failed. Please check your credentials and try again.";
        }
      }
    );
  }

  fbTrackLogin(user) {
    var _this = this;
    let data = {};
    data.userId = user.id;
    data.userName = user.email;
    data.userEmail = user.email;
    _this.$social.fbTrackLogin(data);
  }

  initFB() {
    var _this = this;
    _this.$social.initFB();
  }

  logOnboardingTracking() {
    var _this = this;
    _this.$tracking.reportPostJobClick();
  }

  removeBodyClass() {
    var _this = this;
    _this.$timeout(function () {
      $("body").removeClass();
    });
  }

  jqueryCleanUp() {
    var _this = this;
    _this.$timeout(function () {
      $("#ngProgress-container").remove();
    }, 100);
  }

  set_focus() {
    var _this = this;
    _this.$timeout(function () {
      $(".login-wrap .login-container .login-content form .input-bg.name input").focus();
    }, 500);
  }

  checkThirdPartyParams() {
    if (this.$stateParams.signindata !== null) {
      this.result.status = "error";
      this.result.message =
        "The email " +
        this.$stateParams.signindata.data.username +
        " already exists. Please login by entering your password to connect your Jobble with third party service.";
      this.email = this.$stateParams.signindata.data.username;
      this.connectUser = true;
    }
  }

  checkThirdParty(user, type) {
    if (this.connectUser === true) {
      this.connect(user, type);
    }
  }

  connect(user, type) {
    var _this = this;

    let data = {};
    var type = type;
    var user = user;

    data.type = this.$stateParams.signindata.data.connectedAccountType;
    data.token = this.$stateParams.signindata.data.connectedAccountToken;

    _this.$signon.connect(data, user).then(
      function (response) {
        if (type === "jobbler") {
          _this.$state.go("jobs");
        } else {
          _this.$auth.handlePaymentInfos(user, _this.$stateParams);
        }
      },
      function (error) {
        _this.$state.go("jobs");
      }
    );
  }

  focusOnEmail() {
    this.$timeout(function () {
      $('.sign-up-page .input-container input[type="email"]').focus();
    }, 300);
  }

  validateEmailAndPassword() {
    if (this.password.length > 3) {
      this.signInDisabled = false;
    }
  }

}

SigninController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$location",
  "$window",
  "$stateParams",
  "auth",
  "signon",
  "env",
  "$timeout",
  "security",
  "$rootScope",
  "$scope",
  "tracking",
  "$cookies",
  "social",
  "validation",
];

export default SigninController;



// WEBPACK FOOTER //
// ./client/app/components/signin/signin.controller.js